import React from "react";
import ReactDOM from "react-dom";
import { Router, Route, Switch } from "react-router-dom";
import ApolloClient from "apollo-boost";
import { ApolloProvider } from "@apollo/react-hooks";
import { Spin, Layout } from "antd";
import { About, Home, NotFound, SCPage, SCSPage, System } from "./sections";
import history from "./lib/utils/history";
import PrivateRoute from "./lib/components/PrivateRoute";
import { Auth0Provider, useAuth0 } from "./lib/components/react-auth0-spa";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { AppHeader } from "./lib/components/AppHeader";

interface AppState {
  targetUrl: string;
}

const onRedirectCallback = (appState: AppState) => {
  history.push(
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  );
};

const App = () => {
  const { loading } = useAuth0();

  if (loading) {
    return <Spin size="large" />;
  }

  if (
    window.location.search.includes("code=") &&
    window.location.search.includes("state=")
  ) {
    return <Spin size="large" />;
  }

  const { Header, Content } = Layout;

  return (
    <Router history={history}>
      <Layout id="app">
        <Header>
          <AppHeader />
        </Header>
        <Content>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/about" component={About} />
            <PrivateRoute path="/sc/:id" component={SCPage} />
            <PrivateRoute path="/scs" component={SCSPage} />
            <Route
              path="/system/:id"
              render={(props) => <System {...props} />}
            />
            <Route component={NotFound} />
          </Switch>
        </Content>
      </Layout>
    </Router>
  );
};

const client = new ApolloClient({
  uri: "/api",
});

ReactDOM.render(
  <Auth0Provider
    domain="empyrean-challenge.auth0.com"
    client_id="a3k0lrySOtAvVJVcaxO44uzrnDqqguNq"
    redirect_uri={window.location.origin}
    // @ts-ignore
    onRedirectCallback={onRedirectCallback}
  >
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </Auth0Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
